<template>
  <div>
    <CommonHeader :page="'Liste des catégories'" />
    <div class="card-header border-0">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="mb-0"></h3>
        </div>
        <div class="col text-right">
          <base-button style="background-color:#c2b59b" size="sm" v-b-modal.modal-ajoutprod>Ajouter</base-button>
        </div>
      </div>
      <b-container fluid>
        <b-row>
          <div v-for="(key, index) in values" :key="index">
            <b-col cols="3">
              <div>
                <b-card
                  :title="key.libelle"
                  :img-src="key.image"
                  img-alt="Image"
                  img-top
                  tag="article"
                  style="max-width: 20rem;min-width:15rem;"
                  class="mb-2"
                >
                  <b-button href="#" variant="primary" @click="gotoProduct(key.id)">{{key.productsCount + ' Produit(s)'}}</b-button>
                </b-card>
              </div>
            </b-col>
          </div>
        </b-row>
      </b-container>
    </div>

    <ModalUpdateCategorie ref="updatecategoryModal" @categorieadd="categorieadd"></ModalUpdateCategorie>
    <ModalAddCategorie @categorieadd="categorieadd"></ModalAddCategorie>
    <ModalDeleteCategorie ref="deletecategoryModal" @categorieadd="categorieadd"></ModalDeleteCategorie>
  </div>
</template>
<script>
import ModalUpdateCategorie from "./Categorie/ModalUpdateCategorie";
import ModalAddCategorie from "./Categorie/ModalAjoutCategorie";
import ModalDeleteCategorie from "./Categorie/ModalDeleteCategory";
import CommonHeader from '@/components/CommonHeader'
import { setToken, get } from "@/mixins/api";
export default {
  name: "listecategorie",
  components: {
    ModalUpdateCategorie,
    ModalAddCategorie,
    ModalDeleteCategorie,
    CommonHeader
  },

  data() {
    return {
      values: [],
      userToken:
        localStorage.getItem("userToken") ||
        "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOjEsImlhdCI6MTU3OTczNDkxMSwiZXhwIjoxNjExMjcwOTExfQ.96_I_ZUs7ALBMY4pDsnjbT-fvvagVMsVlpi48eAKWGk"
    };
  },
  methods: {
    categorieadd(element) {
      this.getCategory();
    },
    openPopup(data) {
      this.$refs.updatecategoryModal.getCategorie(data);
      this.$refs.deletecategoryModal.getCategorie(data);
    },
    getCategory() {
      get("categories").then(response => {
        this.values = response.data.data;
      });
    },
    gotoProduct(idCat) {
      this.$router.push({ name: "products", params: { id: idCat } });
    }
  },

  mounted() {
    setToken(this.userToken);
    this.getCategory();
  }
};
</script>
<style>
.btn-primary {
    background-color: rgb(194, 181, 155);
    border-color: rgb(194, 181, 155);
  }
.categories-footer {
  display: flex;
  flex-flow: row nowrap;
}
.gotoproduct {
  cursor: pointer;
}
</style>
